import * as styles from './PostBodySkeleton.module.css'

function PostBodySkeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.textContent}>
        <div className={styles.title}></div>
        <div className={styles.content}></div>
      </div>
      <div className={styles.image}></div>
    </div>
  )
}

export default PostBodySkeleton
